import { Component, ViewChild, Input } from '@angular/core';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { Http } from '@angular/http';
import { ConfigProvider } from '../../providers/config/config';
import 'rxjs/add/operator/map';
import { LoadingProvider } from '../../providers/loading/loading';
import { InfiniteScroll, Events } from 'ionic-angular';

@Component({
  selector: 'sliding-tabs',
  templateUrl: 'sliding-tabs.html'
})
export class SlidingTabsComponent {
  @ViewChild(InfiniteScroll) infinite: InfiniteScroll;

  @Input('type') type;//product data
  products = new Array;
  selected = '';
  page = 0;

  constructor(
		public events: Events,
    public shared: SharedDataProvider,
    public http: Http,
    public config: ConfigProvider,
    public loading: LoadingProvider,
  ) {

		this.events.subscribe('products:pricechange', (data) =>{
			console.log("Page:",this.page);
			this.infinite.enable(true);
			//this.page = 0;
			//this.selected = '';
			//this.getProducts(null,true);
		});
  }


  getProducts(infiniteScroll,hideloading) {
		console.log("Loading:",hideloading);
		if(hideloading == true){
    if (this.page == 0 ) { this.loading.autoHide(700); }
		}
    var data: { [k: string]: any } = {};
    data.customers_id = this.shared.customerData.customers_id;
    data.categories_id = this.selected;
    data.page_number = this.page;
		//console.log("Cust ID:",data.customers_id);
    // if (d.type != undefined)
    //   data.type = d.type;
    data.language_id = this.config.langId;
    this.http.post(this.config.url + 'getAllProducts', data).map(res => res.json()).subscribe(data => {
			//console.log("####Got Products2:",data.product_data);
      this.infinite.complete();
      if (this.page == 0) {
      this.products = new Array;
        // this.loading.hide();
      }
      if (data.success == 1) {
        this.page++;
        var prod = data.product_data;
        for (let value of prod) {
          this.products.push(value);
        }
      }
      if (data.success == 0) { this.infinite.enable(false); }
    });
    // console.log(this.products.length + "   " + this.page);
  }

  //changing tab
  changeTab(c) {
    this.infinite.enable(true);
    this.page = 0;
    if (c == '') this.selected = c
    else this.selected = c.id;
    this.getProducts(null,false);
  }


  ngOnInit() {
    this.getProducts(null,false);
  }



}



// WEBPACK FOOTER //
// ./src/components/sliding-tabs/sliding-tabs.ts